module.exports = __webpack_public_path__ + "static/plants-of-the-gods-f581d5a175fc04192d557bb17eb6cee3.jpg";